var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalculatorBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#E6EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44673 7.21786H7.65331V5.52293C7.65331 5.18195 7.36079 4.90549 7 4.90549C6.63921 4.90549 6.34669 5.18195 6.34669 5.52293V7.21782H4.55331C4.19252 7.21782 3.9 7.49427 3.9 7.83525C3.9 8.17623 4.19252 8.45269 4.55331 8.45269H6.34669V10.1476C6.34669 10.4886 6.63921 10.765 7 10.765C7.36079 10.765 7.65331 10.4886 7.65331 10.1476V8.45269H9.44669C9.80748 8.45269 10.1 8.17623 10.1 7.83525C10.1 7.49427 9.80752 7.21786 9.44673 7.21786Z",
    fill: "#517DDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3677 7H14.6322C14.2831 7 14 7.31472 14 7.70289C14 8.09106 14.2831 8.40578 14.6322 8.40578H19.3678C19.7169 8.40578 20 8.09106 20 7.70289C20 7.31472 19.7169 7 19.3677 7Z",
    fill: "#517DDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3677 14.6H14.6322C14.2831 14.6 14 14.8939 14 15.2565C14 15.6191 14.2831 15.913 14.6322 15.913H19.3678C19.7169 15.913 20 15.6191 20 15.2565C20 14.8939 19.7169 14.6 19.3677 14.6Z",
    fill: "#517DDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3677 16.8471H14.6322C14.2831 16.8471 14 17.141 14 17.5036C14 17.8661 14.2831 18.1601 14.6322 18.1601H19.3678C19.7169 18.1601 20 17.8661 20 17.5036C20 17.141 19.7169 16.8471 19.3677 16.8471Z",
    fill: "#517DDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88827 16.1643L9.25261 14.8C9.5272 14.5255 9.5272 14.0805 9.2527 13.806C8.9782 13.5315 8.53312 13.5315 8.25867 13.806L6.89433 15.1703L5.52998 13.806C5.25553 13.5315 4.81045 13.5315 4.53595 13.806C4.26145 14.0805 4.26145 14.5255 4.53595 14.8L5.9003 16.1643L4.53595 17.5287C4.26145 17.8032 4.26145 18.2482 4.53595 18.5227C4.6732 18.66 4.85306 18.7286 5.03292 18.7286C5.21278 18.7286 5.39269 18.66 5.52989 18.5227L6.89423 17.1584L8.25858 18.5227C8.39583 18.66 8.57573 18.7286 8.75555 18.7286C8.93536 18.7286 9.11531 18.66 9.25252 18.5227C9.52702 18.2482 9.52702 17.8032 9.25252 17.5287L7.88827 16.1643Z",
    fill: "#517DDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalculatorBlue);
export default __webpack_public_path__ + "static/media/IconCalculatorBlue.af9ec28d5c90222cf03c39fd3ef0f285.svg";
export { ForwardRef as ReactComponent };